import React, { useEffect, useState } from 'react';
import { Download } from 'lucide-react';
import axios from '../../axiosConfig';
const apiUrl = process.env.REACT_APP_API_URL

type Step1DownloadProps = {
  onComplete: () => void;
  templateUrl: string;
};

const Step1Download: React.FC<Step1DownloadProps> = ({ onComplete, templateUrl }) => {
    const [isDownloading, setIsDownloading] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string>('');
    const [templateVersion, setTemplateVersion] = useState<string | null>(null);

     useEffect(() => {
    const fetchVersion = async () => {
      try {
        const response = await axios.get(`${apiUrl}/Excel/templateVersion`);
        setTemplateVersion(response.data.version);
      } catch (error) {
        console.error('Error fetching template version:', error);
      }
    };
    fetchVersion();
  }, []);
    const downloadProcessedFile = async () => {
      try {
        setIsDownloading(true);

        const response = await axios.get(`${apiUrl}/Excel/downloadTemplate`, {
          responseType: 'blob',
        });

        const disposition = response.headers['content-disposition'];
        let filename = 'downloaded-file.xlsx';

        if (disposition) {
          const filenameMatch = disposition.match(/filename\*?=([^;]+)/i);
          if (filenameMatch && filenameMatch.length > 1) {
            filename = decodeURIComponent(filenameMatch[1].replace(/UTF-8''/, '').trim().replace(/["']/g, ''));
          }
        }


        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error: any) {
        setErrorMessage(`Error downloading file: ${error.message}`);
      } finally {
        setIsDownloading(false);
      }
    };


  return (
    <div className="w-full">
      <h2 className="text-xl font-semibold mb-4">Download Template</h2>
      <p className="mb-6 text-gray-600">
        First, download the Excel template that you'll need to fill with your data.
        This template contains the required structure for the system to process your information correctly.
      </p>
      
       <div className="flex flex-col items-center">
        <button
          onClick={downloadProcessedFile}
          className="flex items-center px-6 py-3 bg-blue-500 hover:bg-blue-600 text-white font-medium rounded-lg transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-300 focus:ring-offset-2"
        >
          {isDownloading ? (
            <span className="text-sm">Downloading...</span>
          ) : (
            <>
              <Download className="w-5 h-5 mr-2" />
              Download Template
            </>
          )}
        </button>

        {templateVersion && (
          <p className="mt-2 text-sm text-gray-500">Current version: <span className="font-medium">{templateVersion}</span></p>
        )}
      </div>

      <div className="mt-8 p-4 bg-blue-50 border border-blue-200 rounded-lg">
        <h3 className="font-medium text-blue-800 mb-2">Instructions:</h3>
        <ol className="list-decimal list-inside text-sm text-gray-700 space-y-1">
          <li>Download the Excel template using the button above</li>
          <li>Open the template in Microsoft Excel or a compatible spreadsheet application</li>
          <li>Fill in the required data according to the column headers</li>
          <li>Save the file when complete</li>
          <li>Proceed to the next step to upload your completed file</li>
        </ol>
      </div>
    </div>
  );
};

export default Step1Download;
